import * as Yup from 'yup'

export const EINFormSchema = Yup.object().shape({
  file: Yup.string().required('Ein letter is required'),
  ein: Yup.string()
    .required('EIN is required')
    .matches(/^\d{9}$/, 'EIN must be exactly 9 digits'),
  businessName: Yup.string().required('Business name is required'),
  streetAddress: Yup.string().required('Street address is required'),
  city: Yup.string().required('City is required'),
  state: Yup.string().required('State is required'),
  zipCode: Yup.string()
    .required('Zip code is required')
    .matches(/^\d{5}$/, 'Zip code must be exactly 5 digits'),
})
